import React, { useEffect, useState } from 'react';
import './ProfilePage.css';
import { Navbar22 } from "../sections/Nav2Profile/Navbar22";
import { useNavigate } from "react-router-dom";
import config from '../config/config';

function ProfilePage() {
    const [profileData, setProfileData] = useState(null);
    const [selectedCarId, setSelectedCarId] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const statusTranslations = {
        CREATED: "Создана",
        IN_PROGRESS: "В обработке",
        APPROVED: "Одобрена",
        REJECTED: "Отклонена",
        CANCELLED: "Отменена",
        SIGNED: "Подписана",
        EXPIRED: "Истек срок",
        ARCHIVED: "Архивирована",
        WAITING_PAYMENT: "Ожидает оплаты",
        PAID: "Оплачено",
        NEED_INFO: "Требуется информация"
    };

    const phone = localStorage.getItem('phoneNumber');

    const handleNewOrder = () => {
        navigate("/new-order");
    };
    const handleCloseModal = () => setShowModal(false);

    useEffect(() => {
        if (!phone) return;

        fetch(`${config.apiUrl2}/api/profile/get-profile-data`, {
            method: 'GET',
            headers: {
                'phone': phone
            }
        })
            .then(res => {
                if (!res.ok) throw new Error('Ошибка загрузки профиля');
                return res.json();
            })
            .then(data => {
                setProfileData(data);
                if (data.carEntityList.length > 0) {
                    setSelectedCarId(data.carEntityList[0].id);
                }
            })
            .catch(console.error);
    }, [phone]);

    if (!profileData) return <div>Загрузка...</div>;

    const selectedCar = profileData.carEntityList.find(car => car.id === selectedCarId);

    const handleLogout = () => {
        // Удаляем только нужные ключи
        localStorage.removeItem('phoneNumber');
        localStorage.removeItem('userId');
        localStorage.removeItem('userId_createdAt');
        localStorage.removeItem('adminAuth');

        alert('Вы вышли из аккаунта');
        navigate('/'); // лучше использовать navigate вместо window.location.href
    };


    return (
        <div className="profilePage-layout">
            <Navbar22 />
            <div className="profilePage-wrapper">
                <h2>Личный кабинет</h2>

                <div className="profilePage-userInfo">
                    <h3>Информация о пользователе</h3>
                    <table className="profilePage-table">
                        <tbody>
                        <tr><td>ФИО</td><td>{profileData.user.full_name}</td></tr>
                        <tr><td>Паспорт</td><td>{profileData.user.passport_number}</td></tr>
                        <tr><td>Телефон</td><td>{profileData.user.phone_number}</td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="profilePage-actions">
                    <button className="profilePage-logoutBtn" onClick={handleLogout}>Выйти</button>
                    <button className="profilePage-orderBtn" onClick={handleNewOrder}>Новая заявка</button>
                </div>

                {showModal && (
                    <div className="profilePage-modalOverlay">
                        <div className="profilePage-modalContent">
                            <button className="profilePage-closeBtn" onClick={handleCloseModal}>✖</button>
                            {/* Здесь будет компонент выбора авто */}
                        </div>
                    </div>
                )}

                <div className="profilePage-carSelector">
                    <h3>Выберите автомобиль</h3>
                    {profileData.carEntityList.map(car => (
                        <button
                            key={car.id}
                            onClick={() => setSelectedCarId(car.id)}
                            className={car.id === selectedCarId ? 'profilePage-activeCar' : ''}
                        >
                            {car.brandId.name} {car.modelId.name} {car.yearId.year}
                        </button>
                    ))}
                </div>

                {selectedCar && (
                    <div className="profilePage-carInfo">
                        <h3>Информация о выбранном авто</h3>
                        <table className="profilePage-table">
                            <tbody>
                            <tr><td>Владелец ТС</td><td>{selectedCar.ownerFio}</td></tr>
                            <tr><td>Номер</td><td>{selectedCar.carNumber}</td></tr>
                            <tr><td>Техпаспорт</td><td>{selectedCar.techPassport}</td></tr>
                            <tr><td>Марка</td><td>{selectedCar.brandId.name}</td></tr>
                            <tr><td>Модель</td><td>{selectedCar.modelId.name}</td></tr>
                            <tr><td>Год</td><td>{selectedCar.yearId.year}</td></tr>
                            </tbody>
                        </table>
                    </div>
                )}

                {selectedCar?.applicationEntityList?.length > 0 && (
                    <div className="profilePage-applications">
                        <h3>Заявки по автомобилю</h3>
                        <table className="profilePage-table">
                            <thead>
                            <tr>
                                <th>ID заявки</th>
                                <th>Статус</th>
                                <th>Сумма премии</th>
                                <th>Дата</th>
                            </tr>
                            </thead>
                            <tbody>
                            {selectedCar.applicationEntityList.map(app => (
                                <tr key={app.id}>
                                    <td>{app.id}</td>
                                    <td>{statusTranslations[app.status] || app.status}</td>
                                    <td>{app.premiaSumma} сум</td>
                                    <td>{new Date(app.createdAt).toLocaleString()}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {selectedCar?.userServiceEntity?.data?.length > 0 && (
                    <div className="profilePage-services">
                        <h3>Сервисы по автомобилю</h3>
                        <table className="profilePage-table">
                            <thead>
                            <tr>
                                <th>Название сервиса</th>
                                <th>Всего</th>
                                <th>Осталось</th>
                            </tr>
                            </thead>
                            <tbody>
                            {selectedCar.userServiceEntity.data.map((service, idx) => (
                                <tr key={idx}>
                                    <td>{service.service_name}</td>
                                    <td>{service.total_count}</td>
                                    <td>{service.remaining_count}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ProfilePage;
